var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWMin = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 38,
  viewBox: "0 0 50 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 19,
  width: 10,
  height: 1,
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWMin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "e9b612703a5142ab0b1676340a1daed5.svg";